import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { UserData } from './app/shared/service/UserService';

declare var $: any;

if (environment.production) {
  enableProdMode();
}

$.getJSON("assets/config/ui-config.json", (data) => {
  localStorage.setItem('ui-config', JSON.stringify(data));
  UserData.keycloak_url = data.KEYCLOAK_URL;
  UserData.keycloak_realm = data.KEYCLOAK_REALM;
  UserData.keycloak_client = data.KEYCLOAK_CLIENTID;
  UserData.applications = data.applications;
  UserData.app_libraries = data.app_libraries;
  UserData.backend_url = data.BACKEND_URL;
  UserData.basic_vectoring_webgl_url = data.BASIC_VECTORING_WEBGL_URL || '';
  UserData.advanced_vectoring_webgl_url = data.ADVANCED_VECTORING_WEBGL_URL || '';
  UserData.email_service_base_url = data.EMAIL_SERVICE_BASE_URL || '';
  UserData.email_service_app_id = data.EMAIL_SERVICE_APP_ID || '';

  //start SG-5501
  UserData.ivy_chat_url = data.IVY_CHAT_URL;
  UserData.ivy_feedback_url = data.IVY_FEEDBACK_URL;
  UserData.stratagem_feedback_app_id = data.STRATAGEM_FEEDBACK_APP_ID;
  //end SG-5501
  
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}).fail((error) => {
  console.error('Error loading configuration:', error);
  // Bootstrap anyway with default config
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

